import { WZ_SIGNS } from "../../core/constants";
import { getWesternSunSignIndex } from "../zodiac/western/utils";

function localeTagFrom(locale) {
  return locale === "vi" ? "vi-VN" : "en-US";
}

export function formatDashboardDate(date, locale) {
  return date.toLocaleDateString(localeTagFrom(locale), {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

export function formatDashboardShortDate(date, locale) {
  return date.toLocaleDateString(localeTagFrom(locale), {
    month: "long",
    day: "numeric",
  });
}

export function getDashboardGreeting(date, t) {
  const hour = date.getHours();
  if (hour < 12) return t("dashboard_greeting_morning");
  if (hour < 18) return t("dashboard_greeting_afternoon");
  return t("dashboard_greeting_evening");
}

function westernSignNameKey(sign) {
  return `wz_sign_${String(sign.n).toLowerCase()}`;
}

export function getSunSignLabel(dateString, t) {
  const fallback = (sign) => sign.n;
  if (!dateString) {
    const sign = WZ_SIGNS[1];
    return t ? t(westernSignNameKey(sign)) : sign.n;
  }
  const signIndex = getWesternSunSignIndex(dateString);
  const sign = WZ_SIGNS[signIndex];
  if (!sign) {
    const fb = WZ_SIGNS[1];
    return t ? t(westernSignNameKey(fb)) : fb.n;
  }
  return t ? t(westernSignNameKey(sign)) : fallback(sign);
}

/** Stable English slug for logic (not for display). */
export function getSunSignKey(dateString) {
  if (!dateString) return "taurus";
  const signIndex = getWesternSunSignIndex(dateString);
  const sign = WZ_SIGNS[signIndex];
  return sign ? String(sign.n).toLowerCase() : "taurus";
}

export function getMoonSignLabel(date = new Date(), t) {
  const moonCycleMs = 27.321661 * 24 * 60 * 60 * 1000;
  const referenceDate = new Date(Date.UTC(2000, 0, 6, 18, 14, 0));
  const elapsedMs = date.getTime() - referenceDate.getTime();
  const phase = ((elapsedMs % moonCycleMs) + moonCycleMs) % moonCycleMs;
  const moonSignIndex = Math.floor((phase / moonCycleMs) * 12);
  const moonSign = WZ_SIGNS[moonSignIndex % 12];
  if (!moonSign) {
    const fb = WZ_SIGNS[6];
    const name = t ? t(westernSignNameKey(fb)) : fb.n;
    return `${name} ${fb.s}`;
  }
  const name = t ? t(westernSignNameKey(moonSign)) : moonSign.n;
  return `${name} ${moonSign.s}`;
}
